// import React from "react";

// const FooterComponents = () => {
//   return <>footer file</>;
// };

// export default FooterComponents;
import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './style.css';

import { BsFacebook, BsLinkedin, BsTwitter, BsStackOverflow, BsGoogle, BsGithub, BsYoutube } from "react-icons/bs";
const FooterComponent = ()=>{
    
    return (
        <>
            <footer className='myFooter'>
                <Container>
                   <Row>
                        <Col className=''>
                            <h3 className='head_3'>Ping me up !! </h3>
                            <ul className='socialIconsList'>
                              
                                <li>
                                    <a rel="noreferrer" href="https://www.linkedin.com/in/sambhavnrana/" target="_blank">
                                        <BsLinkedin />
                                    </a>
                                </li>
                                <li>
                                    <a rel="noreferrer" href="https://github.com/sambhavnrana" target="_blank">
                                        <BsGithub />
                                    </a>
                                </li> 
                            </ul>
                            
                        </Col>
                        <Col className='col-12'>
                            <div className="footerCopyright">
                                <small>Developed and Designed  by <a href="https://github.com/sambhavnrana" target="_blank" rel="noreferrer">SAMBHAV RANA</a>.</small>
                            </div>
                        </Col>
                   </Row>
                </Container>
            </footer>
        </>
    )
}

export default FooterComponent;
